import * as React from 'react'

import { ChevronLeft, X } from 'lucide-react'

import { Button } from '~/client/src/shared/components/shadcn-ui/button'
import Localization from '~/client/src/shared/localization/LocalizationManager'

interface IProps {
  title: string
  onBack?: () => void
  onClose?: () => void
  closeLabel?: string
}

const OptionsHeader: React.FC<IProps> = ({
  title,
  onBack,
  onClose,
  closeLabel = Localization.translator.close,
}) => {
  return (
    <div
      data-slot="options-header"
      className="tw:flex tw:items-center tw:justify-between tw:gap-2 tw:shrink-0"
    >
      <div className="tw:flex tw:items-center tw:gap-2 tw:min-w-0">
        {onBack && (
          <Button
            variant="ghost"
            size="icon-xs"
            className="tw:-my-0.5"
            aria-label={Localization.translator.back}
            onClick={onBack}
          >
            <ChevronLeft className="tw:size-4" />
          </Button>
        )}
        {/* Wraps rather than truncates — a clipped title can't be revealed. */}
        <span className="tw:min-w-0 tw:text-app-dense-medium tw:break-words">
          {title}
        </span>
      </div>
      {onClose && (
        <Button
          variant="ghost"
          size="icon-xs"
          className="tw:-my-0.5"
          aria-label={closeLabel}
          onClick={onClose}
        >
          <X className="tw:size-4" />
        </Button>
      )}
    </div>
  )
}

export default OptionsHeader
